import Profile from "views/examples/Profile.js";
import Login from "views/examples/Login.js";

import Consultas from "views/examples/consultas";

import OrdenesHistorico from "views/examples/OrdenesHistorico";
import ReporteDistribuidor from "views/examples/ReporteDistribuidor";

var routesDistribuidor = [
  {
    path: "/perfil",
    name: "Perfil",
    icon: "ni ni-settings-gear-65 text-blue",
    component: <Profile />,
    layout: "/admin",
  },
  {
    name: " Gestión",
    icon: "ni ni-settings-gear-65 text-blue",
    routes: [
      {
        path: "/OrdenesHisorico",
        name: "Órdenes Historico",
        icon: "ni ni-single-02 text-blue",
        component: <OrdenesHistorico />,
        layout: "/admin",
      },
    ],
  },

  {
    name: " Consultas",
    icon: "ni ni-chat-round text-blue",
    routes: [
   
      {
        path: "/distribuidor",
        name: "Reporte Distribuidor",
        icon: "fa fa-question-circle text-blue",
        component: <ReporteDistribuidor />,
        layout: "/admin",
      },
    ],
  },

  {
    name: " Autenticación",
    hidden: true, // Esta propiedad se utiliza para ocultar las rutas de autenticación
    routes: [
      {
        path: "/login",
        icon: "fa fa-sign-out-alt text-blue",
        name: "",
        component: <Login />,
        layout: "/auth",
      },
    ],
  },
];

export default routesDistribuidor;
